import { ShieldCheck, Lock, Eye, FileText } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8 font-body">
      <div className="border-b border-border pb-6 space-y-2">
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-primary font-semibold">Legal & Transparency</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900">Privacy Policy</h1>
        <p className="text-slate-500 text-sm">Last updated: August 2026</p>
      </div>

      <div className="bg-card border border-border rounded-3xl p-8 sm:p-10 space-y-6 text-slate-700 leading-relaxed text-sm sm:text-base shadow-sm">
        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <Lock className="w-5 h-5 text-primary" /> 1. Information We Collect
          </h2>
          <p>
            Tablezy collects minimal information necessary to deliver our digital menu service. For cafe and restaurant owners contacting us, we collect owner names, business names, mobile numbers, locations, and table counts. For diners scanning QR codes, no login or personal information is required to browse digital menus.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <Eye className="w-5 h-5 text-primary" /> 2. How We Use Your Information
          </h2>
          <p>
            Contact form information submitted by restaurant owners is used solely to respond to menu requests, provide technical support, and maintain merchant database records. We do not sell or trade your contact information to third-party advertisers.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-primary" /> 3. Data Security & Storage
          </h2>
          <p>
            All submitted lead and support records are encrypted during transmission and stored securely in protected databases. Access to administrative data is restricted strictly to authorized Tablezy personnel via secure authentication tokens.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
            <FileText className="w-5 h-5 text-primary" /> 4. Cookies & Analytics
          </h2>
          <p>
            We use standard session cookies to remember browser preferences and ensure fast loading speeds for mobile diners. You can disable cookies in your web browser at any time without affecting your ability to scan and view Tablezy menus.
          </p>
        </section>
      </div>
    </div>
  );
}
